export const BODY_SCHEMA = {
  phone: "",
  name: "",
  email: "",
  lastname: "",
  message: "",
};
